import {
  subtype as s,
  subtypeCatalog as c,
  withSubtypeImages as withImages,
} from './catalog-builder';

export const HOME_PRODUCT_SUBTYPE_CATALOGS = [
  c(
    'pillow',
    ['Pillow'],
    withImages('pillow', [
      s(
        'square-throw',
        'Square throw',
        'equal-length sides',
        'compact decorative volume'
      ),
      s('lumbar', 'Lumbar', 'long rectangular body', 'low vertical height'),
      s('bolster', 'Bolster', 'long cylindrical body', 'round end panels'),
      s('round', 'Round', 'circular face', 'radial edge seam'),
      s(
        'floor-cushion',
        'Floor cushion',
        'large low body',
        'broad sitting surface'
      ),
      s(
        'body',
        'Body',
        'extra-long rectangular body',
        'sleep-length proportions'
      ),
      s('wedge', 'Wedge', 'sloping top plane', 'triangular side profile'),
      s(
        'neck-roll',
        'Neck roll',
        'small cylindrical body',
        'neck-scale length'
      ),
      s('euro', 'Euro', 'large square face', 'bed-scale proportions'),
      s(
        'boudoir',
        'Boudoir',
        'small rectangular face',
        'compact decorative proportions'
      ),
      s(
        'box-cushion',
        'Box cushion',
        'flat top and bottom panels',
        'vertical side boxing'
      ),
      s('backrest', 'Backrest', 'upright support body', 'broad lower base'),
    ])
  ),
  c(
    'wall-art',
    ['Wall Art'],
    withImages('wall-art', [
      s(
        'framed-print',
        'Framed print',
        'flat printed artwork',
        'visible perimeter frame'
      ),
      s('canvas', 'Canvas', 'wrapped textile surface', 'stretcher-depth edges'),
      s('poster', 'Poster', 'unframed flat sheet', 'thin edge profile'),
      s(
        'textile-hanging',
        'Textile hanging',
        'soft hanging panel',
        'visible suspension edge'
      ),
      s(
        'diptych',
        'Diptych',
        'two coordinated panels',
        'intentional panel gap'
      ),
      s(
        'triptych',
        'Triptych',
        'three coordinated panels',
        'intentional panel gaps'
      ),
      s(
        'panel-set',
        'Panel set',
        'multiple coordinated panels',
        'modular wall arrangement'
      ),
      s(
        'sculptural-relief',
        'Sculptural relief',
        'raised surface forms',
        'shallow wall depth'
      ),
      s(
        'metal-wall-art',
        'Metal wall art',
        'rigid cut or formed elements',
        'wall-offset depth'
      ),
      s(
        'wood-wall-art',
        'Wood wall art',
        'rigid wood-based panel',
        'visible object depth'
      ),
      s(
        'tapestry',
        'Tapestry',
        'large woven hanging panel',
        'soft draped edge'
      ),
      s(
        'shadow-box',
        'Shadow box',
        'deep perimeter frame',
        'recessed internal display'
      ),
    ])
  ),
  c(
    'blanket',
    ['Blanket'],
    withImages('blanket', [
      s('throw', 'Throw', 'compact rectangular panel', 'sofa-scale coverage'),
      s(
        'bed-blanket',
        'Bed blanket',
        'large rectangular panel',
        'mattress-scale coverage'
      ),
      s(
        'weighted',
        'Weighted',
        'evenly distributed filled body',
        'substantial flat drape'
      ),
      s(
        'electric',
        'Electric',
        'blanket panel',
        'integrated control connection'
      ),
      s(
        'picnic',
        'Picnic',
        'portable ground-sized panel',
        'foldable rectangular form'
      ),
      s('baby', 'Baby', 'small rectangular panel', 'infant-scale proportions'),
      s('outdoor', 'Outdoor', 'ground-capable panel', 'reinforced perimeter'),
      s(
        'wearable',
        'Wearable',
        'blanket body with arm access',
        'body-wrapping form'
      ),
      s(
        'stadium',
        'Stadium',
        'compact lap-sized panel',
        'portable rectangular form'
      ),
      s(
        'travel',
        'Travel',
        'compact body-covering panel',
        'packable proportions'
      ),
      s(
        'cooling',
        'Cooling',
        'thin body-covering panel',
        'flat breathable construction'
      ),
      s(
        'emergency',
        'Emergency',
        'ultrathin foldable sheet',
        'full-body coverage'
      ),
    ])
  ),
  c(
    'sofa',
    ['Sofa'],
    withImages('sofa', [
      s(
        'three-seat',
        'Three-seat',
        'three-person seat span',
        'continuous sofa body'
      ),
      s('loveseat', 'Loveseat', 'two-person seat span', 'compact sofa body'),
      s(
        'sectional',
        'Sectional',
        'joined seating sections',
        'extended corner or chaise segment'
      ),
      s(
        'modular',
        'Modular',
        'separable seat modules',
        'reconfigurable repeated units'
      ),
      s(
        'corner',
        'Corner',
        'right-angle seating plan',
        'integrated corner seat'
      ),
      s(
        'chaise',
        'Chaise',
        'single elongated seat',
        'extended leg-support deck'
      ),
      s(
        'sofa-bed',
        'Sofa bed',
        'sofa seating body',
        'integrated convertible sleep deck'
      ),
      s('curved', 'Curved', 'arcing seat plan', 'curved back alignment'),
      s(
        'chesterfield',
        'Chesterfield',
        'rolled arms matching back height',
        'deep buttoned body'
      ),
      s(
        'tuxedo',
        'Tuxedo',
        'arms matching back height',
        'straight box-like perimeter'
      ),
      s(
        'track-arm',
        'Track-arm',
        'straight rectangular arms',
        'clean vertical arm faces'
      ),
      s('roll-arm', 'Roll-arm', 'outward-curving arms', 'rounded arm fronts'),
      s('armless', 'Armless', 'open seat sides', 'back-and-seat body only'),
    ])
  ),
  c(
    'lamp',
    ['Lamp'],
    withImages('lamp', [
      s(
        'table',
        'Table',
        'compact freestanding base',
        'shade or light head above base'
      ),
      s('floor', 'Floor', 'tall freestanding stem', 'floor-standing base'),
      s(
        'desk-task',
        'Desk/task',
        'adjustable task head',
        'compact desk base or clamp'
      ),
      s(
        'bedside',
        'Bedside',
        'compact low height',
        'soft close-range light head'
      ),
      s(
        'reading',
        'Reading',
        'directional light head',
        'user-positionable arm or stem'
      ),
      s(
        'portable',
        'Portable',
        'self-contained carryable body',
        'integrated grip or compact base'
      ),
      s('arc', 'Arc', 'long curved arm', 'offset overhead light head'),
      s(
        'torchiere',
        'Torchiere',
        'tall upright stem',
        'upward-facing bowl light'
      ),
      s(
        'bankers',
        'Banker’s',
        'horizontal task shade',
        'short articulated stem'
      ),
      s('tripod', 'Tripod', 'three-legged base', 'raised central light head'),
      s('mushroom', 'Mushroom', 'domed shade', 'short centered stem'),
    ])
  ),
  c(
    'plate',
    ['Plate'],
    withImages('plate', [
      s('dinner', 'Dinner', 'large round eating surface', 'shallow raised rim'),
      s('side', 'Side', 'small round eating surface', 'shallow raised rim'),
      s('salad', 'Salad', 'medium round eating surface', 'shallow raised rim'),
      s(
        'dessert',
        'Dessert',
        'small presentation surface',
        'defined perimeter rim'
      ),
      s('pasta', 'Pasta', 'wide rim', 'shallow central bowl'),
      s('soup', 'Soup', 'broad rim', 'deeper central bowl'),
      s('charger', 'Charger', 'oversized flat plate', 'broad decorative rim'),
      s(
        'appetizer',
        'Appetizer',
        'small serving surface',
        'compact plate proportions'
      ),
      s(
        'bread-and-butter',
        'Bread-and-butter',
        'very small round surface',
        'shallow rim'
      ),
      s(
        'compartment',
        'Compartment',
        'divided eating surface',
        'raised internal partitions'
      ),
      s('tasting', 'Tasting', 'small presentation plate', 'single-bite scale'),
      s('saucer', 'Saucer', 'small shallow dish', 'central cup recess'),
    ])
  ),
  c(
    'vase',
    ['Vase'],
    withImages('vase', [
      s('bud', 'Bud', 'narrow single-stem opening', 'small upright body'),
      s('cylinder', 'Cylinder', 'straight vertical walls', 'round open mouth'),
      s('bottle', 'Bottle', 'narrow neck', 'broader lower body'),
      s(
        'amphora',
        'Amphora',
        'narrow neck',
        'two side handles',
        'rounded body'
      ),
      s('floor', 'Floor', 'tall freestanding body', 'floor-scale proportions'),
      s('bulbous', 'Bulbous', 'rounded wide body', 'narrower mouth'),
      s(
        'fluted',
        'Fluted',
        'vertically ribbed body',
        'repeated longitudinal channels'
      ),
      s('pedestal', 'Pedestal', 'raised footed base', 'vessel body above stem'),
      s('wide-mouth', 'Wide-mouth', 'broad open rim', 'open generous neck'),
      s('hanging', 'Hanging', 'suspension point', 'lightweight vessel body'),
      s('wall', 'Wall', 'flat wall-facing back', 'forward-projecting vessel'),
      s(
        'organic-form',
        'Organic-form',
        'asymmetric vessel outline',
        'irregular flowing contours'
      ),
    ])
  ),
  c(
    'mug',
    ['Mug'],
    withImages('mug', [
      s('classic', 'Classic', 'cylindrical drinking body', 'side handle'),
      s('espresso', 'Espresso', 'small drinking body', 'small side handle'),
      s('latte', 'Latte', 'tall drinking body', 'side handle'),
      s('camp', 'Camp', 'straight utility body', 'rounded rim', 'side handle'),
      s('travel', 'Travel', 'tall lidded body', 'drinking aperture'),
      s('insulated', 'Insulated', 'double-wall body', 'fitted lid'),
      s(
        'beer-stein',
        'Beer stein',
        'large handled body',
        'substantial base',
        'wide drinking rim'
      ),
    ])
  ),
] as const;
